import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';
import newInboxRuleAction from './actions/NewInboxRuleAction';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "Options" */ './lazyIndex');
});
// export types
export { newInboxRuleAction, };
export var lazyMoveInboxRule = new LazyAction(lazyModule, function (m) { return m.moveInboxRule; });
export var lazyRunRuleNow = new LazyImport(lazyModule, function (m) { return m.runRuleNow; });
export var lazyInitializeInboxRulesFolders = new LazyAction(lazyModule, function (m) { return m.initializeInboxRulesFolders; });
//# sourceMappingURL=index.js.map